export default __webpack_public_path__ + "static/media/createUTM.8ae755b7.svg";